import { type ReactNode, useEffect, useState } from "react";
import { SidebarProvider } from "@getgreenline/blaze-ui";
import { type ThemeMode } from "../../hooks/use-theme";
import { formatPageTitle } from "../../utils/page-title";
import { AppSidebarNav } from "./app-sidebar-nav";
import { TopNavigation } from "./top-navigation";

type AppLayoutProps = {
  children: ReactNode;
  currentPageLabel: string;
  currentStepLabel?: string;
  sidebarVariant?: "platform" | "backoffice";
  onLogout: () => void;
  theme: ThemeMode;
  onThemeChange: (theme: ThemeMode) => void;
};

export function AppLayout({
  children,
  currentPageLabel,
  currentStepLabel,
  sidebarVariant = "platform",
  onLogout,
  theme,
  onThemeChange,
}: AppLayoutProps) {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  useEffect(() => {
    document.title = formatPageTitle(currentPageLabel);
  }, [currentPageLabel]);

  return (
    <div className="blaze-ui-root tw:min-h-screen tw:bg-muted/30">
      <div className="tw:min-h-screen tw:bg-background">
        <SidebarProvider defaultOpen className="tw:w-full">
          <div className="tw:flex tw:min-h-screen tw:w-full">
            <AppSidebarNav isOpen={sidebarOpen} variant={sidebarVariant} />
            <div className="tw:min-h-screen tw:min-w-0 tw:flex-1 tw:bg-background">
              <TopNavigation
                currentPageLabel={currentPageLabel}
                currentStepLabel={currentStepLabel}
                onToggleSidebar={() => setSidebarOpen((open) => !open)}
                onLogout={onLogout}
                theme={theme}
                onThemeChange={onThemeChange}
              />
              {children}
            </div>
          </div>
        </SidebarProvider>
      </div>
    </div>
  );
}
